import { ApiService } from "../api.service";
var PerformanceService = (function () {
    function PerformanceService(apiService) {
        this.apiService = apiService;
    }
    PerformanceService.prototype.getConfigByName = function (configName) {
        return this.apiService.loadConfig("./assets/config/performance/" + configName + ".json");
    };
    PerformanceService.prototype.getAllSceneList = function () {
        return this.getConfigByName("sceneList");
    };
    /*保存情景模拟的答题 */
    PerformanceService.prototype.saveExercisesAnswers = function (exerciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/maxSimulation/saveExercisesAnswers'
        });
    };
    // 保存情景模拟第一题的答题
    PerformanceService.prototype.saveFirstChoiceAnswers = function (exerciciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/maxSimulation/saveFirstChoiceAnswers'
        });
    };
    /*保存进度 */
    PerformanceService.prototype.saveProgress = function (exerciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/maxSimulation/saveProgress/' + exerciseId
        });
    };
    /*重做情景模拟 */
    PerformanceService.prototype.reset = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/reset/' + exerciseId
        });
    };
    /* 获取驱动变革情景模拟第一个选择题内容 */
    PerformanceService.prototype.getFirstChoiceInfo = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/getFirstChoiceInfo/' + exerciseId
        });
    };
    /* 获取当前步骤 */
    PerformanceService.prototype.getProgress = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/getProgress/' + exerciseId
        });
    };
    /* 获取选择题后动画 */
    PerformanceService.prototype.getQuestionAnswerAnimate = function (optionList) {
        var animateList = [{
                "begin": [{
                        "el": '<div id="revolution_step3_0" class="result"><div class="container">' + this.getQuestionAnswerContent(optionList) + '</div></div>'
                    }
                ],
                "end": [{
                        "el": "#revolution_step3_0",
                        "className": "fadeOut"
                    }
                ]
            }];
        return animateList;
    };
    /* 获取选择题后动画 */
    PerformanceService.prototype.getQuestionAnswerAnimate2 = function (optionList) {
        var animateList = [{
                "begin": [{
                        "el": '<div id=\"revolutionall-person2\"><div id=\"talkBox2\" class=\"talkBox2\"><div id=\"talkBoxContent2\" class=\"fontSize16\">' + this.getQuestionAnswerContent2(optionList) + '</div><div id=\"talkBoxName2\" class=\"fontSize16 talkBoxName2\">魏宇</div></div></div>'
                    }
                ],
                "end": [{
                        "el": "#revolutionall-person2",
                        "className": "fadeOut"
                    }
                ]
            }];
        return animateList;
    };
    /* 获取选择题后内容 */
    PerformanceService.prototype.getQuestionAnswerContent = function (optionList) {
        var answerContent = "<ul>";
        optionList.forEach(function (item, index) {
            if (item.selected) {
                answerContent += "<li>" + item.description + "</li>";
            }
        });
        answerContent += "</ul>";
        return answerContent;
    };
    PerformanceService.prototype.getQuestionAnswerContent2 = function (optionList) {
        var answerContent = "";
        optionList.forEach(function (item, index) {
            if (item.selected) {
                answerContent += item.description;
            }
        });
        return answerContent;
    };
    /* 获取用户驱动变革情景模拟决策树  */
    PerformanceService.prototype.getExercises = function (exerciseId, step) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/exercises/' + exerciseId + '/' + step
        });
    };
    /* 获取用户驱动变革情景模拟决策树(历史回顾)  */
    PerformanceService.prototype.getExercisesHis = function (exerciseId, step) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/exercisesHis/' + exerciseId + '/' + step
        });
    };
    /* 完成驱动变革情景模拟  */
    PerformanceService.prototype.finishExercises = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/finish/' + exerciseId
        });
    };
    /* 获取当前阶段的导师反馈  */
    PerformanceService.prototype.getTutorFeedback = function (exerciseId, step) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/getTutorFeedback/' + exerciseId + '/' + step
        });
    };
    /* 获取用户驱动变革能力下的情景模拟列表  */
    PerformanceService.prototype.getPracticeList = function (learningPathId, practiceMetaId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/createAndGet/' + learningPathId + '/' + practiceMetaId
        });
    };
    PerformanceService.prototype.setSavePoint = function (exerciseId, data) {
        return this.apiService.ajax({
            'type': 'post',
            'data': data,
            'url': '/sr/maxSimulation/saveMaxSceneReview'
        });
    };
    PerformanceService.prototype.getSavePoint = function (exerciseId) {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/maxSimulation/getMaxSceneReview/' + exerciseId
        });
    };
    return PerformanceService;
}());
export { PerformanceService };



// WEBPACK FOOTER //
// ./src/app/case-practice-performance/performanceService.ts.pre-build-optimizer.js